import React, { ReactNode, FunctionComponent } from 'react';

type PageHeaderProps = {
    children: ReactNode;
};

const PageHeader: FunctionComponent<PageHeaderProps> = ({ children }) => (
    <header className="page-header">{children}</header>
);

export default PageHeader;
